/* eslint-disable import/prefer-default-export */
import icon from '../assets/medsupply_favicon.ico';

export const medsupplyConfig = {
  title: 'MedSupply Partners',
  catalog: 'partner',
  partner: 'medsupply',
  origin: 'https://medsupplypartners.com',
  host: 'https://seating.medsupplypartners.com',
  logo: 'https://ecomseating.s3.amazonaws.com/images/other/MSP-logo.png',
  logoURL: 'https://ecomseating.s3.amazonaws.com/images/other/MSP-logo.png',
  buildAChair: 'medsupply',
  businessInfo: 'MedSupply Partners, LLC, 3715 Atlanta Industrial Pkwy NW, Suite B, Atlanta, GA 30331',
  headerTheme: '#CFE2F3',
  secondaryTheme: '#005DAA',
  footerTheme: '#CFE2F3',
  headerTextColor: '#000000',
  footerTextColor: '#000000',
  buttonTextColor: '#F7F7F7',
  extraAttributes: {
    trackId: 'G-8WZ310WDE9',
    icon,
  },
};
